import { useEffect, useState } from 'react';
import { useGetApplication } from '~/controllers/wizard';
import { getEmail } from '~/utils/getDecodedJwt';

const useAuthorizedSignatories = () => {
  const applicationQuery = useGetApplication();
  const currentUserEmail = getEmail();
  const authorizedRepresentatives = applicationQuery.data?.payload.authorizedRepresentative;

  const authorizedSignatories =
    applicationQuery.data?.payload.authorizedRepresentative?.filter((item) => item.isAuthorizedSignatory) ?? [];
  const isMultipleSignatories = authorizedSignatories ? authorizedSignatories.length > 0 : null;
  const previouslySelectedAuthorizedSignatory = applicationQuery.data?.payload.authorizedSignatory;
  const selectedAuthorizedRepresentativeIndex = previouslySelectedAuthorizedSignatory
    ? (applicationQuery.data?.payload.authorizedRepresentative ?? []).findIndex(
        (ar) => ar.email === previouslySelectedAuthorizedSignatory.email,
      )
    : !isMultipleSignatories && authorizedSignatories.length > 0
    ? (applicationQuery.data?.payload.authorizedRepresentative ?? []).findIndex(
        (ar) => ar.email === authorizedSignatories[0].email,
      )
    : -1;
  const selectedAuthorizedRepresentative =
    selectedAuthorizedRepresentativeIndex < 0 || !applicationQuery.data?.payload.authorizedRepresentative
      ? undefined
      : applicationQuery.data?.payload.authorizedRepresentative[selectedAuthorizedRepresentativeIndex];

  const [authorizedSignatoryEmail, setAuthorizedSignatoryEmail] = useState<string | undefined>();
  useEffect(() => {
    setAuthorizedSignatoryEmail(selectedAuthorizedRepresentative?.email);
  }, [selectedAuthorizedRepresentative?.email]);

  const resultingAuthorizedRepresentative =
    applicationQuery.data?.payload.authorizedRepresentative &&
    authorizedSignatoryEmail &&
    applicationQuery.data?.payload.authorizedRepresentative.find((ar) => ar.email === authorizedSignatoryEmail);

  const isCurrentUserAuthorizedSignatory: boolean | undefined =
    authorizedRepresentatives &&
    authorizedRepresentatives?.filter((ar) => ar?.email?.toLocaleLowerCase() === currentUserEmail)?.length > 0;

  return {
    isMultipleSignatories,
    selectedAuthorizedRepresentativeIndex,
    authorizedSignatoryEmail,
    setAuthorizedSignatoryEmail,
    resultingAuthorizedRepresentative,
    isCurrentUserAuthorizedSignatory,
  };
};

export default useAuthorizedSignatories;
